export default "__VITE_ASSET__BxNvtMKc__"